import { useState } from "react";
import CentralModal from "../../../../components/lib/centralModal";
import CustomButton from "../../../../components/lib/customButton";

const BatchMenuStatusChangeModal = ({ isOpen, onClose, selectedItems, itemType, onConfirm }) => {
    const [isActive, setIsActive] = useState(true);

    if (!isOpen) return null;

    const itemsSafe = selectedItems || [];

    const handleSubmit = async () => {
        await onConfirm(isActive);
    };

    return (
        <CentralModal 
            isOpen={isOpen} 
            onClose={onClose} 
            title={`Alterar Status de ${itemsSafe.length} ${itemType}(s)`}
            className="md:max-w-md"
        >
            <div className="flex flex-col gap-4 p-4">
                <p className="text-gray-600">
                    Você selecionou <strong>{itemsSafe.length}</strong> itens.
                    Deseja alterar o status de todos para:
                </p>

                <div className="flex flex-col gap-2">
                    <label className="text-sm font-medium text-gray-700">Novo Status</label>
                    <select
                        className="w-full p-2 border border-gray-300 rounded-md outline-none focus:border-blue-500 bg-white"
                        value={isActive}
                        onChange={(e) => setIsActive(e.target.value === 'true')}
                    >
                        <option value="true">Ativo</option>
                        <option value="false">Inativo</option>
                    </select>
                </div>

                <div className="bg-blue-50 border-l-4 border-blue-400 p-3 mt-2">
                    <p className="text-sm text-blue-700">
                        Itens inativos não aparecerão para venda no aplicativo.
                    </p>
                </div>

                <div className="flex justify-end gap-3 mt-4 pt-4 border-t border-gray-100">
                    <CustomButton 
                        onClick={onClose} 
                        text="Cancelar" 
                        buttonType="cancel" 
                    />
                    <CustomButton 
                        onClick={handleSubmit} 
                        text="Confirmar" 
                        buttonType="confirm" 
                    />
                </div>
            </div>
        </CentralModal>
    );
};

export default BatchMenuStatusChangeModal;